export default "__VITE_ASSET__c$WcehuX__"